import React, { useEffect } from "react";

type HeapAnalyticsProps = {
  heapId: string;
}

const HeapAnalytics: React.FC<HeapAnalyticsProps> = ({ heapId }: HeapAnalyticsProps) => {
  const DEFAULT_SCRIPT_ID = "illustration-heap-analytics";

  const getHeapScript = (id: string | number) => `
    window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};
    heap.load("${id}");
  `;

  useEffect(() => {
    if (!heapId) {
      throw new Error("You need to provide your Heap Analytics ID.");
    }

    if (!document) {
      return;
    }

    const hasScript = !!document.querySelector(DEFAULT_SCRIPT_ID);

    if (hasScript) {
      return;
    }

    const script = document.createElement("script");

    script.innerHTML = getHeapScript(heapId);
    script.id = DEFAULT_SCRIPT_ID;
    script.async = true;
    document.head.append(script);
  }, [heapId]);

  return null;
};

export default HeapAnalytics;
